<template>
  <div class="select-box">
    <div v-if="visibleLabel">
      <label class="fw-bold">{{ visibleLabel }}</label>
    </div>
    <multiselect
      v-model="value"
      :options="options"
      :label="label"
      :value-prop="valueProp"
      :can-deselect="canDeselect"
      style="'width: 100%'"
      @update:modelValue="newSelected"
    />
  </div>
</template>

<script>
import { ref } from 'vue';

import Multiselect from '@vueform/multiselect';

export default {
  name: 'CustomSelect',

  components: {
    Multiselect,
  },

  props: {
    options: Array,
    label: String,
    visibleLabel: {
      default: '',
      type: String,
    },
    valueProp: {
      type: String,
      default: 'id',
    },
    selectedValue: Number,
    canDeselect: {
      type: Boolean,
      default: false,
    },
  },

  setup(props, { emit }) {
    const value = ref(props.selectedValue);

    function newSelected() {
      emit('new-selected', value.value);
    }

    return {
      newSelected,
      value,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '../../../node_modules/@vueform/multiselect/themes/default.css';
@import '../../assets/css/colors.scss';

::v-deep(.multiselect-option.is-selected){
  background: $blue;
  &:hover {
    background: $blue;
  }
}

::v-deep(.multiselect-input) {
  border-color: $light-grey;
}

::v-deep(.multiselect) {
  width: 100%;
}

label {
  margin-right: 10px;
}

.select-box {
  align-items: center;
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  margin-bottom: 20px;
  width: 100%;
}

</style>
